export default __webpack_public_path__ + "img/how-to-use-slide03.2b1fdf81.webp";